export default __webpack_public_path__ + "static/media/biblioteka.9052a147.jpg";